/**
 * react-native → react-native-web + stubs for APIs RN-web does not export.
 * Used only by the PWA Vite alias; Metro still resolves the real package.
 *
 * Note: react-native-web has no default export — only named exports.
 */
import { Keyboard as RNWebKeyboard } from 'react-native-web';

export * from 'react-native-web';

/**
 * RN-web Keyboard has dismiss / isVisible / addListener but not `metrics()`.
 * Auth forms call Keyboard.metrics() for keyboard avoidance — stub as closed.
 */
export const Keyboard = {
  ...RNWebKeyboard,
  metrics(): { screenX: number; screenY: number; width: number; height: number } | undefined {
    return undefined;
  },
};

/** Avoid RN-web's noisy "BackHandler is not supported on web" console errors. */
export const BackHandler = {
  addEventListener(_event: string, _handler: () => boolean | null | undefined) {
    return { remove() {} };
  },
  removeEventListener() {},
  exitApp() {},
};

/** Never used on web (Platform.OS !== 'ios'); stub satisfies the import graph. */
export const ActionSheetIOS = {
  showActionSheetWithOptions(
    _options: {
      title?: string;
      message?: string;
      options: string[];
      cancelButtonIndex?: number;
      destructiveButtonIndex?: number;
    },
    _callback?: (buttonIndex: number) => void,
  ) {},
  showShareActionSheetWithOptions(
    _options: Record<string, unknown>,
    _failure?: (error: Error) => void,
    _success?: (completed: boolean, method: string) => void,
  ) {},
};

export const PermissionsAndroid = {
  PERMISSIONS: {
    POST_NOTIFICATIONS: 'android.permission.POST_NOTIFICATIONS',
    CAMERA: 'android.permission.CAMERA',
    READ_EXTERNAL_STORAGE: 'android.permission.READ_EXTERNAL_STORAGE',
    WRITE_EXTERNAL_STORAGE: 'android.permission.WRITE_EXTERNAL_STORAGE',
    ACCESS_FINE_LOCATION: 'android.permission.ACCESS_FINE_LOCATION',
    ACCESS_COARSE_LOCATION: 'android.permission.ACCESS_COARSE_LOCATION',
  },
  RESULTS: {
    GRANTED: 'granted',
    DENIED: 'denied',
    NEVER_ASK_AGAIN: 'never_ask_again',
  },
  async check(_permission: string) {
    return true;
  },
  async request(_permission: string) {
    return 'granted';
  },
  async requestMultiple(_permissions: string[]) {
    return {} as Record<string, string>;
  },
};
